module.exports = __webpack_public_path__ + "img/bell-logo.9f979618.svg";